import PatientList from './PatientList';

export default PatientList;
